module.exports = __webpack_public_path__ + "static/media/mongodb-leaf.d8c8d898.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Languages/img/mongodb-leaf.svg
// module id = 115
// module chunks = 0